export default __webpack_public_path__ + "static/media/ExercisePlan.0b21745e.svg";